






























import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';

import { Endpoints } from '@/ts/store/Constants';
import Card from '@/components/shared/admin/layout/Card.vue';
import ProjectSelector from '@/components/Selects/ProjectSelector.vue';
import CorporationSelector from '@/components/Selects/CorporationSelector.vue';
import CopyKnowledgeBaseCard from '@/components/Admin/SystemTools/CopyKnowledgeBaseCard.vue';
import ImportKnowledgeBaseCard from '@/components/Admin/SystemTools/ImportKnowledgeBaseCard.vue';
import ImportBulkPortfolioDataCard from '@/components/Admin/SystemTools/ImportBulkPortfolioDataCard.vue';
import ImportRentAdjustmentsCard from '@/components/Admin/SystemTools/ImportRentAdjustmentsCard.vue';
import SendWelcomeMailsCard from '@/components/Admin/SystemTools/SendWelcomeEmailsCard.vue';

@Component({
    components: {
        Card,
        ProjectSelector,
        CorporationSelector,
        CopyKnowledgeBaseCard,
        ImportKnowledgeBaseCard,
        ImportBulkPortfolioDataCard,
        ImportRentAdjustmentsCard,
        SendWelcomeMailsCard,
    },
})

export default class SystemTools extends Vue {
    public corporations: any = [];
    public projects: any = [];

    get allLanguages() {
        return this.$store.getters['Localization/getAllLanguages'];
    } 

    public created() {
        axios.get(Endpoints.Neckbeard.GET_ALL_CORPORATIONS)
            .then((response) => {
                this.corporations = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        axios.get(Endpoints.Neckbeard.GET_ALL_PROJECTS)
            .then((response) => {
                this.projects = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
    }
}
